import React, { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import api from '../utils/intercepter/axiosConfig.js'
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const VerifyTF = () => {

  const [idNotaire, setIdNotaire] = useState(null);
  const [idUser, setIdUser] = useState(null);
  const [numberTf, setNumeroTf] = useState('')
  const [nni, setNni] = useState('')
  const [idCercle, setIdCercle] = useState('');

  const [cercles, setCercles] = useState([]);
  const [tfDetails, setTfDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState('')

  const [errors, setErrors] = useState({
    numberTf: '',
    nni: '',
    idCercle: ''
  });


  // Fonction de validation NNI
  const isValidNNI = (value) => {
    if (!/^\d{10}$/.test(value)) return false;
    return parseInt(value) % 97 === 1;
  }

  const navigate = useNavigate();

   // Récupérer Infos utilisateur à partir du token JWT

  useEffect(() => {
  const token = localStorage.getItem("token");
  if(token){
    const decoded = jwtDecode(token);
    setIdNotaire(decoded.data.id_notaire);
    setIdUser(decoded.data.id);
  }
}, []);


  useEffect(() => {
    
  // Appel API pour récupérer les cercles
    const fetchCercles = async () => {
      try {
        
        const response = await api.get("/auth/allCercle");
        setCercles(response.data.response);
        console.log(response.data.message); // tableau de cercles
      } catch (error) {
        console.error("Erreur lors du chargement des cercles  : ", error);
      }
    };
    fetchCercles();
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault()

    console.log(numberTf, nni, idCercle)

    let valid = true;

    const newErrors = {numberTf: '', nni: '', idCercle: ''}

    // Validaton Numéro TF
    if (!/^\d+$/.test(numberTf)) {
      newErrors.numberTf = 'Le numéro TF doit être un entier.';
      valid = false;
    }

    // Validation NNI
  if (!/^\d{10}$/.test(nni)) {
    newErrors.nni = 'Le NNI doit contenir exactement 10 chiffres.';
    valid = false;
  } else if (!isValidNNI(nni)) {
    newErrors.nni = 'Le NNI n’est pas valide.';
    valid = false;
  }

  // Validation Cercle
  const cercleExists = cercles.some(cercle => cercle.id === parseInt(idCercle));

  if(!cercleExists){
    newErrors.idCercle = "Le cercle sélectionné n'existe pas.";
    valid = false;
  }

  setErrors(newErrors);

  if(!valid) return;

  // Nettoyage avant l'appel API

    setErrorMessage('');
    setTfDetails(null)

    try {

      const responseCheck = await api.post("/auth/checkEtatMutation",{
        "num_tf":numberTf
      });

      if(responseCheck.data.status){
                  const response = await api.post("/auth/consultation_tf",{
                        num_tf: numberTf,
                        id_cercle: idCercle,
                        cni: nni,
                      });

                      if(response.data && response.data.tf){
                        setTfDetails(response.data.tf);
                      }else{
                        setErrorMessage(response.data.message);
                      }
      }
      else{
          setErrorMessage(responseCheck.data.message)
      }
      
    } catch (error) {
      if(error.response && error.response.data){
        setErrorMessage(error.response.data.message);
      }
      else{
        setErrorMessage("Une erreur est survenue.")
      }
    }

  };





    return <>
    <div className="container py-5" style={{ paddingBottom: '250px' }}>
  <div className="row justify-content-center">
    <div className="col-12 col-md-8 col-lg-6">
      <div className="card ">
        <div className="card-body">
          <h5 className="card-title mb-4 text-center">
          <FaCheckCircle className="text-dark fw-bold me-2" /> 
          Vérifier un TF
          </h5>
          <hr />

          {errorMessage && (
            <div className="alert alert-danger mt-4 text-center">
              {errorMessage}
              </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="n_TF">Numéro TF</label>
              <input type="text" className="form-control" name="numberTf" id="n_TF" placeholder="Entrez votre numéro TF"
              onChange={(e) => setNumeroTf(e.target.value)}
              required
              />
              {errors.numberTf && <small className="text-danger">{errors.numberTf}</small>}
            </div>

            <div className="form-group mb-3">
              <label htmlFor="id_cercle">Cercle</label>
              <select
                className="form-select"
                id="id_cercle"
                value={idCercle}
                onChange={(e) => setIdCercle(e.target.value)}
                required
              >
                <option value="">Sélectionnez un cercle</option>
                {cercles.map((cercle) => (
                  <option key={cercle.id} value={cercle.id}>
                    {cercle.libelle}
                  </option>
                ))}
              </select>
              {errors.idCercle && <small className="text-danger">{errors.idCercle}</small>}
            </div>

            <div className="form-group mb-4">
              <label htmlFor="nni">NNI</label>
              <input type="text" className="form-control" name="nni" id="nni" placeholder="Entrez votre NNI"
              onChange={(e) => setNni(e.target.value)}
              onFocus={(e) => {
                 setTimeout(() => {
                    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }, 300);
              }}
              required
              />
              {errors.nni && <small className="text-danger">{errors.nni}</small>}
            </div>
            <div className="d-grid">
              <button type="submit" className="btn  btn-success" >Trouver</button>
            </div>
          </form>

          

{tfDetails && (
  <div className="card mt-4 border-success">
    <div className="card-body">
      <h5 className="card-title text-success">Détails du Titre Foncier :</h5>
      <table className="table table-bordered table-striped mt-3">
        <tbody>
          <tr>
            <th className="text-start">Nom Propriétaire</th>
            <td className="text-end">{tfDetails.nom}</td>
          </tr>
          <tr>
            <th className="text-start">NNI Propriétaire</th>
            <td className="text-end">{tfDetails.cni}</td>
          </tr>
          <tr>
            <th className="text-start">Numéro TF</th>
            <td className="text-end">
              <span className="badge bg-warning text-white">{tfDetails.num_tf}</span>
            </td>
          </tr>
          <tr>
            <th className="text-start">Moughataa</th>
            <td className="text-end">{tfDetails.mouqataa}</td>
          </tr>
          <tr>
            <th className="text-start">Lot</th>
            <td className="text-end">{tfDetails.lots}</td>
          </tr>
          <tr>
            <th className="text-start">Ilot</th>
            <td className="text-end">{tfDetails.ilot}</td>
          </tr>
        </tbody>
      </table>
      <div className="d-grid mt-3">
        
        <div className="row">
          <div className="col">
            <button className="btn btn-success w-100 btn-sm" onClick={() => {
          // navigate(`/creer-vente/${idNotaire}/${tfDetails.num_tf}`);
          navigate('/new/vente',{
            state: { idNotaire, numTf: tfDetails.num_tf,idUser, nni : tfDetails.cni, idCercle: tfDetails.id_cercle}

          }
        )
        }}>Initier la vente</button>
          </div>

        </div>
      
      </div>
    </div>
  </div>
)}

        </div>
      </div>
    </div>
  </div>
</div>

    </>
}


export default VerifyTF



//  <div className="row">
//           <div className="col-12 col-md-6">
//             <button className="btn btn-success w-100" onClick={() => {
//           // navigate(`/creer-vente/${idNotaire}/${tfDetails.num_tf}`);
//           navigate('/new/vente',{
//             state: { idNotaire, numTf: tfDetails.num_tf,idUser}
//           }
//         )
//         }}>Initier la vente</button>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-12 col-md-6">
//             <button className="btn btn-warning w-100">Initier hypo</button>
//           </div>
//         </div>